import { put } from '../api.service';

// Shared API service for version preference
export const updateVersionPreference = async (versionType: 1 | 2) => {
  try {
    await put(`/userpreference/version?versionType=${versionType}`, {});
    return true;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};